/*
Ravi 02/23/2023 2780168262 implemented test functionality
//suresh peddavoora 02/24/2023 2780168262 New UI changes
Prakash 26/04/2023 2780168262 fixed button spacing issue
Sohel 05/17/2023 3075154998 Add Import File Functionality
Sohel 05/19/2023 3075154998 Import Manager Test Payload Changes
Akhila 5/22/2023 3075154998 implemented warning toast message validation on diffrent file
Sohel 05/25/2023 3075154998 Added Dialog message instead of Toast message
Ravi 05/29/2023 3075154998 Added validation on client Code
Sohel 05/29/2023 3075154998 Fixed client Code Changes
Ravi 05/30/2023 3075154998 fixed validation issue
Sohel 06/01/2023 3075154998 Fixed Import Test Issue
Akhila 06/06/2023 3075154998 added code and description in action
Akhila 06/07/2023 3075154998 comment out code and description in test and import file action menu
Ravi 06/27/2023 3075154998  added folder path and output file name
Ravi 06/15/2023 3075154998 removed by default initial value folder path and output file name
Sohel 09/23/2023 5158105392 Add Duplicate Check field in import file popup
*/
import React, { useState, useContext, useEffect } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import {
  Grid,
  Button,
  FormHelperText,
  /* FormControl,
  InputLabel,
  Select,
  MenuItem, */
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { ThemeContext } from '../../../../../themes/ThemeProvider';
import DragAndDrop from '../../../../GalaxyCoreWindows/DocumentsManagement/Drag&Drop';
import {
  fetchBasicInfoData,
  postTestImportMaster,
  resetTestErrorMessage,
} from '../../../../../redux/reducers/DataManager';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import { getClientCodeDropDownData } from '../../../../../redux/reducers/TriggerGroup';
import DialogBox from '../../../../../components/DialogBox';
import WarningErrorPopup from '../../DataManagerRecord/AddDataManagerRecord/SearchMapDataTransform/WarningErrorPopup';
/* const duplicateCheckOptions = [
  { key: 'Y', value: 'Yes' },
  { key: 'N', value: 'No' },
]; */
const EnableTestDialoge = ({ sideBarScan, rowData, importFile = false, type }) => {
  const { reusableInputStyles } = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const { clientCodeDropdownData } = useSelector(({ addTriggerGroup }) => addTriggerGroup);
  const { testError } = useSelector(({ dataManagerGroup }) => dataManagerGroup);
  const [warningOpen, setWarningOpen] = useState(false);
  const [testErrors, setTestErrors] = useState(false);
  const dispatch = useDispatch();
  const initialValues = {
    uploadedFile: null,
    clientCode: '',
    duplicateCheck: 'Y',
    // outputFileName: basicInfoData?.reportOutputFileName
    // ? basicInfoData?.reportOutputFileName
    // : "",
    // reportpath: basicInfoData?.exportfolderPath
    // ? basicInfoData?.exportfolderPath
    // : "",
  };
  const handleValidationClose = () => {
    setWarningOpen(false);
    setTestErrors(false);
    dispatch(resetTestErrorMessage());
  };
  const dataManagerId = rowData?.dataManagerId ? rowData?.dataManagerId : '';
  useEffect(() => {
    if (dataManagerId) {
      dispatch(fetchBasicInfoData({ dataManagerId: dataManagerId, tabType: 'Import' }));
    }
  }, [dataManagerId]);

  useEffect(() => {
    if (testError) {
      setTestErrors(true);
    }
  }, [testError]);
  const schema = Yup.object().shape({
    uploadedFile: Yup.mixed()
      .test('uploadedFile', 'Please upload the file', function (value, context) {
        const { from } = context;
        const uploadedFile = from[0]?.value?.uploadedFile;
        if (uploadedFile === null || uploadedFile?.length === 0) {
          return false;
        } else {
          return true;
        }
      })
      .nullable(),
    clientCode: importFile
      ? Yup.mixed().test('clientCode', `Client Code is required`, (value) => {
        if (!value?.clientNumber && rowData?.dmType === 'New Account Import') {
          return false;
        } else {
          return true;
        }
      })
      : null,
    // reportpath: Yup
    // .mixed()
    // .test("reportpath", "Invalid Report Folder path, Can't contain //", function (value) {
    //   const regex = /^(?!.*\/\/)/;
    //   const { parent } = this;
    //   if (regex.test(parent?.reportpath)) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // })
    // .test(
    //   "reportpath",
    //   `Invalid Report Folder path, Can't contain ${backslash + backslash}`,
    //   function (value) {
    //     const { parent } = this;
    //     if (parent?.reportpath && (parent?.reportpath).includes(`${backslash + backslash}`)) {
    //       return false;
    //     } else {
    //       return true;
    //     }
    //   }
    // ),
  });
  const [fileSizeError, setFileSizeError] = useState(false);
  useEffect(() => {
    dispatch(getClientCodeDropDownData());
  }, []);
  return (
    <>
      <Formik
        onSubmit={(values, { resetForm }) => {
          const formData = new FormData();
          // formData.append("dmRequest", values.uploadedFile[0]);
          if (importFile) {
            formData.append(
              'dmRequest',
              new Blob(
                [
                  JSON.stringify({
                    dmCode: rowData.dmCode,
                    dmId: rowData.dataManagerId ? rowData.dataManagerId : '',
                    type: 'Import',
                    defaultClient: values?.clientCode?.clientNumber
                      ? values?.clientCode?.clientNumber
                      : '',
                    exportfolderPath: values?.reportpath ? values?.reportpath : '',
                    reportOutputFileName: values?.outputFileName ? values?.outputFileName : '',
                    duplicateCheck:
                      rowData?.dmType === 'New Account Import' && values?.duplicateCheck
                        ? values?.duplicateCheck
                        : '',
                  }),
                ],
                { type: 'application/json' },
              ),
            );
            formData.append('multipartFile', values.uploadedFile[0]);
          } else {
            // formData.append(
            //   "multipartFile",
            //   new Blob(
            //     [
            //       JSON.stringify({
            //         multipartFile: values.uploadedFile[0],
            //       }),
            //     ],
            //     { type: "application/json" }
            //   )
            // );
            formData.append('multipartFile', values.uploadedFile[0]);
          }

          const type = 'Import';

          if (values && values.uploadedFile) {
            const reader = new FileReader();
            reader.onload = function (e) {
              const base64EncodedFile = e.target.result.split(',')[1];
              const fileName = values.uploadedFile[0].name.split('.');
              dispatch(
                postTestImportMaster(
                  {
                    dmCode: rowData?.dmCode ? rowData?.dmCode : '',
                    dmId: rowData.dataManagerId ? rowData.dataManagerId : '',
                    type: type,
                    defaultClient: values?.clientCode?.clientNumber
                      ? values?.clientCode?.clientNumber
                      : '',
                    exportfolderPath: values?.reportpath ? values?.reportpath : '',
                    reportOutputFileName: values?.outputFileName ? values?.outputFileName : '',
                    duplicateCheck: values.duplicateCheck,
                    content: base64EncodedFile,
                    ext: fileName[1],
                    file: fileName[0],
                  },
                  importFile,
                ),
              );
            };

            reader.readAsDataURL(values.uploadedFile[0]);
          }
        }}
        initialValues={initialValues}
        validationSchema={schema}
        enableReinitialize
      >
        {(props) => {
          const { values, errors, touched, handleSubmit, handleReset, setFieldValue } = props;
          return (
            <>
              <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                <div className={`${sideBarScan ? '' : 'col'}`}>
                  <Grid container className="new-standard-textfields" spacing={2}>
                    {importFile && (
                      <>
                        <Grid
                          item
                          xs={3}
                          xl={6}
                          md={6}
                          sm={4}
                          className="form-group new-standard-textfields"
                        >
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            name="clientCode"
                            id="clientCode"
                            size="small"
                            value={values.clientCode}
                            options={clientCodeDropdownData || []}
                            getOptionLabel={(option) => {
                              return option?.clientNumber ? option?.clientName : '';
                            }}
                            onChange={(e, value) => {
                              setFieldValue('clientCode', value);
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  {...params}
                                  error={touched.clientCode && errors.clientCode}
                                  variant="outlined"
                                  margin="dense"
                                  required={rowData?.dmType === 'New Account Import'}
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                  label="Client Code"
                                  placeholder="Select Client Code"
                                />
                              </div>
                            )}
                          />
                          <FormHelperText style={{ color: 'red' }} variant="outlined">
                            {touched.clientCode && errors.clientCode}
                          </FormHelperText>
                        </Grid>
                        {/* {rowData?.dmType === 'New Account Import' && (
                          <Grid
                            item
                            xs={3}
                            xl={6}
                            md={6}
                            sm={4}
                            className={`form-group ${classes.selectField}`}
                          >
                            <FormControl variant="outlined" fullWidth>
                              <InputLabel id="demo-simple-select-label">Duplicate Check</InputLabel>
                              <Select
                                fullWidth
                                className={`select-gender ${classes.labelName}`}
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                name="duplicateCheck"
                                label="Duplicate Check"
                                value={values.duplicateCheck ?? 'Y'}
                                onChange={(e) => {
                                  setFieldValue('duplicateCheck', e.target.value);
                                }}
                              >
                                <MenuItem value="none" key="none" disabled>
                                  <span className="defaultSelected">Select Duplicate Check</span>
                                </MenuItem>
                                {duplicateCheckOptions.map((option) => {
                                  return (
                                    <MenuItem value={option.key} key={option.key}>
                                      {option.value}
                                    </MenuItem>
                                  );
                                })}
                              </Select>
                            </FormControl>
                          </Grid>
                        )} */}
                      </>
                    )}
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <DragAndDrop
                        enableTest={true}
                        setFieldValue={setFieldValue}
                        uploadedFile={values.uploadedFile}
                        fileSizeError={fileSizeError}
                        error={errors.uploadedFile}
                        helperText={errors && errors.uploadedFile}
                        setFileSizeError={setFileSizeError}
                        setWarningOpen={setWarningOpen}
                        warningOpen={warningOpen}
                      />
                    </Grid>
                  </Grid>

                  <div className="d-flex justify-content-end new-standard-textfields">
                    <Button
                      variant="outlined"
                      type="submit"
                      disabled={fileSizeError}
                      className={`search-btn ml-1 ${classes.buttonRoot}`}
                    >
                      {importFile ? 'Import' : 'Test'}
                    </Button>
                  </div>
                </div>
                <DialogBox
                  open={warningOpen || testErrors}
                  dialogClose={handleValidationClose}
                  title="Warning !"
                  maxWidth="sm"
                >
                  <WarningErrorPopup
                    handleValidationClose={handleValidationClose}
                    warningOpen={warningOpen}
                    testErrors={testErrors}
                    testError={testError}
                  />
                </DialogBox>
              </form>
            </>
          );
        }}
      </Formik>
    </>
  );
};

export default EnableTestDialoge;
